import styled from "styled-components"
import Breakpoints from "../../../components/shared/breakpoints"
import withAnimation from "../../util/withAnimation"
import VariantContainer, { IVariantContainerProps } from "../variant-container"

interface IGridProps extends IVariantContainerProps {
  noPadding?: Boolean
}

interface IBlogGridProps {
  noPadding?: {
    sm?: boolean
    md?: boolean
    lg?: boolean
  }
}

/**
 * Content focused grid specific to the blog with different columns per breakpoint.
 * @param noPadding - If true, no padding is applied.
 */
export const BlogGrid = styled(VariantContainer)<IBlogGridProps>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 8px;
  grid-auto-rows: min-content;
  z-index: 110;
  width: 100%;
  padding-left: ${(props) => (props.noPadding?.sm ? "0" : "5%")};
  padding-right: ${(props) => (props.noPadding?.sm ? "0" : "5%")};
  box-sizing: border-box;

  @media screen and (min-width: ${Breakpoints.md}) {
    padding-left: ${(props) => (props.noPadding?.md ? "0" : "5%")};
    padding-right: ${(props) => (props.noPadding?.md ? "0" : "5%")};
    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 24px;
  }

  @media screen and (min-width: ${Breakpoints.lg}) {
    padding-left: ${(props) => (props.noPadding?.lg ? "0" : "5%")};
    padding-right: ${(props) => (props.noPadding?.lg ? "0" : "5%")};
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 32px;
    max-width: 1440px;
    margin: 0 auto;
  }
`

export const Grid = styled(VariantContainer)<IGridProps>`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-column-gap: 12px;
  grid-auto-rows: min-content;
  z-index: 110;
  width: 100%;
  padding: 0 ${(props) => (props.noPadding ? "0" : "20px")};
  box-sizing: border-box;

  @media screen and (min-width: ${Breakpoints.md}) {
    padding: 0 ${(props) => (props.noPadding ? "0" : "40px")};
  }

  @media screen and (min-width: ${Breakpoints.lg}) {
    grid-column-gap: 24px;
    max-width: 1440px;
    margin: 0 auto;
  }
`

//@ts-ignore
Grid.Animated = withAnimation(Grid)

export default styled(Grid)``
